import React, { useState, useEffect } from 'react';
import { Clock, Calendar } from 'lucide-react';

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isExpired: false
  });

  useEffect(() => {
    // Data de encerramento: 23/11/2025 às 23:59:59
    const endDate = new Date('2025-11-23T23:59:59');

    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = endDate - now;

      if (difference <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isExpired: true
        });
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({
        days,
        hours,
        minutes,
        seconds,
        isExpired: false
      });
    };

    // Calcula imediatamente
    calculateTimeLeft();

    // Atualiza a cada segundo
    const timer = setInterval(calculateTimeLeft, 1000);

    // Cleanup
    return () => clearInterval(timer);
  }, []);

  if (timeLeft.isExpired) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <Calendar className="w-12 h-12 text-red-500 mx-auto mb-3" />
        <h3 className="text-xl font-bold text-red-700 mb-2">
          Enquete Encerrada
        </h3>
        <p className="text-red-600">
          O prazo para participação foi encerrado em 23/11/2025
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-primary-50 to-blue-50 border border-primary-200 rounded-lg p-6">
      <div className="flex items-center justify-center mb-4">
        <Clock className="w-6 h-6 text-primary-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">
          Tempo Restante para Participar
        </h3>
      </div>
      
      <p className="text-center text-gray-600 mb-4 text-sm">
        A enquete encerra em <strong>23 de Novembro de 2025</strong>
      </p>

      <div className="grid grid-cols-4 gap-3">
        {/* Dias */}
        <div className="bg-white rounded-lg p-3 shadow-sm text-center">
          <div className="text-3xl font-bold text-primary-600">
            {String(timeLeft.days).padStart(2, '0')}
          </div>
          <div className="text-xs text-gray-500 mt-1 uppercase font-medium">
            {timeLeft.days === 1 ? 'Dia' : 'Dias'}
          </div>
        </div>

        {/* Horas */}
        <div className="bg-white rounded-lg p-3 shadow-sm text-center">
          <div className="text-3xl font-bold text-primary-600">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <div className="text-xs text-gray-500 mt-1 uppercase font-medium">
            {timeLeft.hours === 1 ? 'Hora' : 'Horas'}
          </div>
        </div>

        {/* Minutos */}
        <div className="bg-white rounded-lg p-3 shadow-sm text-center">
          <div className="text-3xl font-bold text-primary-600">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <div className="text-xs text-gray-500 mt-1 uppercase font-medium">
            Min
          </div>
        </div>

        {/* Segundos */}
        <div className="bg-white rounded-lg p-3 shadow-sm text-center">
          <div className="text-3xl font-bold text-primary-600">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <div className="text-xs text-gray-500 mt-1 uppercase font-medium">
            Seg
          </div>
        </div>
      </div>

      <div className="mt-4 text-center">
        <p className="text-xs text-gray-500">
          Compartilhe esta enquete e incentive mais pessoas a participarem!
        </p>
      </div>
    </div>
  );
};

export default CountdownTimer;
